import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, OutlinedInput, Select, Stack, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import axios from '../../util/Axios';

import { ValidateEmail } from '../../util/Validation';
// import { COUNTRIES, VALID_HOSPITALS } from '../../util/Constants';
import { COUNTRIES } from '../../util/Constants';

export function Invitation({ open, onClose }) {
  const [name, setName] = useState('');
  const handleChangeName = (event) => {
    setName(event.target.value);
  };

  const [email, setEmail] = useState('');
  const handleChangeEmail = (event) => {
    setEmail(event.target.value);
  };

  const [hospital, setHospital] = useState('');

  const [hospitals, setHospitals] = useState([]);

  const [userRole, setUserRole] = useState('DOCTOR');

  const [country, setCountry] = useState('');

  const handleClose = () => {
    clearFields();
    onClose();
  };

  const clearFields = () => {
    setName('');
    setEmail('');
    setHospital(null);
  };
  const handleSave = () => {
    axios(`invitations`, {
      method: 'POST',
      data: { fullName: name, email, hospital: hospital, role: userRole, country: country },
    }).then((resp) => handleClose());
  };

  const invitationValid = () => {
    return name && email && ValidateEmail(email);
  };

  useEffect(() => {
    axios.get('/hospitals')
      .then(response => {
        setHospitals(response.data);
      });
  }, []);

  return (
    <>
      <Dialog open={open}>
        <DialogTitle>Invite User</DialogTitle>
        <DialogContent>
          <Stack spacing={3} sx={{ width: 500, marginTop: 1 }}>
            <TextField label="Full Name" value={name} onChange={handleChangeName} required={true} />
            <TextField error={!ValidateEmail(email)} label="Email" value={email} onChange={handleChangeEmail} required={true} />
            <FormControl>
              <InputLabel id="filter_label">Choose hospital</InputLabel>
              <Select value={hospital} onChange={(event) => setHospital(event.target.value)} input={<OutlinedInput label="Choose hospital" />}>
                {hospitals.map((hospital) => (
                  <MenuItem key={hospital.id} value={hospital.name}>
                    {hospital.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl>
              <InputLabel id="filter_label">Choose role</InputLabel>
              <Select value={userRole} onChange={(event) => setUserRole(event.target.value)} input={<OutlinedInput label="Choose role" />}>
                <MenuItem key="DOCTOR" value="DOCTOR">
                  Doctor
                </MenuItem>
                <MenuItem key="LEGAL_TEAM" value="LEGAL_TEAM">
                  Legal Team
                </MenuItem>
              </Select>
            </FormControl>
            <FormControl>
              <InputLabel id="country_label">Choose country</InputLabel>
              <Select value={country} onChange={(event) => setCountry(event.target.value)} input={<OutlinedInput label="Choose country" />}>
                {COUNTRIES.map(({ name, code }) => (
                  <MenuItem key={name} value={code}>
                    {name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button disabled={!invitationValid()} variant="contained" onClick={handleSave}>
            Invite
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
